import { zodResolver } from "@hookform/resolvers/zod";
import { useTranslation } from "react-i18next";
import { SearchModelFormModel, searchModelFormModel } from "./search-model-form-model";
import { useForm } from "react-hook-form";
import { modelsAtom, Model } from "@/atoms/model";
import { useAtom } from "jotai";
import { useState } from "react";
import { useLoading } from "@/utils/hooks/loading.hooks";
import { ModelUsecase } from "@/usecases/model/ModelUsecase";
import { usePrivatePageContext } from "@/utils/hooks/private-page.hooks";
import { UnauthorizedError } from "@/@types/api-error";
import { searchModels } from "@/utils/model";

export const useSearchModelView = () => {
  const { t } = useTranslation();
  const [totalModels, setTotalModels] = useAtom(modelsAtom);
  const { apiClient, logout } = usePrivatePageContext();
  const { loading, showLoading, hideLoading } = useLoading();
  const [models, setModels] = useState<Model[]>([]);
  const [errorMessage, setErrorMessage] = useState<string>("");

  const form = useForm<SearchModelFormModel>({
    resolver: zodResolver(searchModelFormModel),
    defaultValues: { model: { modelCode: "", modelName: "" } },
    mode: "onChange",
  });

  const onSubmit = form.handleSubmit(
    async (data) => {
      showLoading();

      try {
        // NOTE: ログイン後、取得できなかった場合は再度APIを叩く
        let totalModelsToSearch = totalModels;
        if (totalModelsToSearch.length === 0) {
          const response = await ModelUsecase.models(apiClient);
          totalModelsToSearch = response.items;
          setTotalModels(totalModelsToSearch);
        }

        const searchedModels = searchModels(data.model, totalModelsToSearch);
        setModels(searchedModels);
        if (searchedModels.length === 0) {
          setErrorMessage(t("search_model_not_found_error_message"));
          return;
        }
        setErrorMessage("");
      } catch (error) {
        if (error instanceof UnauthorizedError) {
          logout();
          return;
        }
        setModels([]);
        setErrorMessage(t("search_model_server_error_message"));
      } finally {
        hideLoading();
      }
    },
    (errors) => {
      setModels([]);
      if (errors.model) setErrorMessage(t("search_model_validation_error_message"));
    },
  );

  return {
    t,
    form,
    models,
    onSubmit,
    errorMessage,
    loading,
  };
};
